import React, { createContext, useState, useEffect } from 'react';
import { getAuthToken, getMe, login, logout, register, setAuthToken } from '../services/api';

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = getAuthToken();
    if (!token) {
      setLoading(false);
      return;
    }

    getMe()
      .then(res => setUser(res.data.user))
      .catch(() => {
        setAuthToken(null);
        setUser(null);
      })
      .finally(() => setLoading(false));
  }, []);

  const handleLogin = async (data) => {
    const res = await login(data);
    setAuthToken(res.data.token);
    setUser(res.data.user);
    return res;
  };

  const handleRegister = async (data) => {
    const res = await register(data);
    setAuthToken(res.data.token);
    setUser(res.data.user);
    return res;
  };

  const handleLogout = async () => {
    try {
      await logout();
    } catch (error) {
      // Ignore logout transport failures and clear local auth state anyway.
    }
    setAuthToken(null);
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, loading, handleLogin, handleRegister, handleLogout }}>
      {children}
    </AuthContext.Provider>
  );
};
